import React, { useState, useEffect, useMemo } from "react";
import ReactDatatable from "@ashvin27/react-datatable";
import { Link, useParams } from "react-router-dom";
import { api } from "../../../utils/Api";
import ModalAddSalaryWork from "./ModalAddSalaryWork";
import ModelSalaryWorkView from "./ModalSalaryWorkView";

const table_config = {
  key_column: "id",
  page_size: 10,
  length_menu: [10, 20, 50],
  show_filter: true,
  show_pagination: true,
  button: {
    excel: false,
    print: false,
  },
  language: {
    loading_text: "Please be patient while data loads...",
  },
};

const table_header = [
  {
    name: "",
    width: "10",
  },
  {
    name: "Users",
    width: "30",
  },
  {
    name: "Amount",
    width: "30",
  },
  {
    name: "",
    width: "20",
  },
];

const deleted_table_header = [
  {
    name: "",
    width: "10",
  },
  {
    name: "Users",
    width: "30",
  },
  {
    name: "Type",
    width: "15",
  },
  {
    name: "Deleted User",
    width: "20",
  },
  {
    name: "Deleted At",
    width: "20",
  },
  {
    name: "",
    width: "5",
  },
];

export default function SalaryWork(props: any) {
  const [work_salary_data, SetWorkSalaryData] = useState([]);
  const [is_loading, SetIsLoading] = useState({ open: false, type: 1 });
  const [openAddModal, SetopenAddModal] = useState(false);
  const [ViewModal, SetViewModal] = useState({
    is_open: false,
    record: {},
    type: "view",
  });
  // let { userid } = useParams();
  const [user_id] = useState(useParams());

  const [deleted_salary_data, SetDeletedSalaryData] = useState([]);
  const [selected_data, SetSelectedData] = useState({
    value: "",
    i: "",
  });
  const [id_value, SerIdValue] = useState(useParams());

  const table_column = [
    { key: "id", text: "Id", sortable: true },
    { key: "user", text: "User", sortable: true },
    // { key: "roles", text: "UserRole", sortable: true },
    {
      key: "action",
      text: "Action",
      width: 100,
      className: "text-center",
      align: "center",
      cell: (record: any, index: any) => {
        return (
          <div className="dropdown">
            <div
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={require("../../../assets/icon/svg/more-horizontal.svg")}
                className="action_img cursor"
              />
            </div>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <div className="dropdown-item">
                  <div
                    className="cursor"
                    onClick={() => {
                      // SetViewModal({
                      //   is_open: true,
                      //   record: record,
                      //   type: "view",
                      // });
                      console.log("View");
                    }}
                    style={{ marginRight: "5px" }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/eye.svg")}
                      className="action_menu_img cursor"
                    />
                    &nbsp; View
                  </div>
                </div>
              </li>

              <li>
                <div className="dropdown-item">
                  <div
                    className="cursor"
                    onClick={() => {
                      delete_work_salary(index, record);
                      console.log("delete record:", record);
                    }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/trash-2.svg")}
                      className="action_menu_img cursor"
                    />
                    &nbsp; Delete
                  </div>
                </div>
              </li>
            </ul>
          </div>
        );
      },
    },
  ];

  const delete_table_column = [
    { key: "id", text: "Id", sortable: true },
    { key: "user", text: "User", sortable: true },
    {
      key: "quantity_type",
      text: "Type",
      sortable: true,
      cell: (record: any, index: any) => {
        if (record.quantity_type == 1) {
          return "Item Wise";
        } else {
          return "Duration Wise";
        }
      },
    },
    {
      key: "deleted_user",
      text: "Deleted User",
      sortable: true,
      cell: (record: any, index: any) => {
        return record.deleted_user + "@" + record.deleted_username;
      },
    },
    { key: "deleted_at", text: "Deleted At", sortable: true },
    {
      key: "action",
      text: "Action",
      width: 250,
      className: "text-center",
      align: "center",
      cell: (record: any, index: any) => {
        return (
          <div className="dropdown">
            <div
              id="dropdownMenuButton2"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={require("../../../assets/icon/svg/more-horizontal.svg")}
                className="action_img cursor"
              />
            </div>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
              <li>
                <div className="dropdown-item">
                  <div
                    className="cursor"
                    onClick={() => {
                      // SetViewModal(true);
                      console.log("View");
                    }}
                    style={{ marginRight: "5px" }}
                  >
                    <img
                      src={require("../../../assets/icon/svg/eye.svg")}
                      className="action_menu_img cursor"
                    />
                    &nbsp; View
                  </div>
                </div>
              </li>
            </ul>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    console.log("user if id :", user_id);
    console.log("salary work On mount :", props);
    get_work_salary();
  }, []);

  function AddModalOnClose(data: any) {
    console.log("Close Modal values: ", data);
    if (data.action == "save") {
      SetWorkSalaryData((prevValue) => {
        if (prevValue == undefined) {
          prevValue = [];
          prevValue.push(data.value);
        } else {
          prevValue.push(data.value);
        }
        return [...prevValue];
      });
    }
    SetopenAddModal(false);
  }

  function ViewModalOnClose(data: any) {
    SetViewModal(false);
  }

  async function get_work_salary() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
    };
    let response = await api("/outlet/work_salary", pass_data);
    console.log("salary get response :", response.response);
    SetWorkSalaryData(response.response.work_salary);
    SetDeletedSalaryData(response.response.deleted_work_salary);
  }

  async function delete_work_salary(i: any, record: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
      post: {
        salary_id: record.id,
      },
    };
    let response = await api("/outlet/delete_work_salary", pass_data);
    console.log("delete_work_salary response :", response);
    if (response.status_code == 200) {
      let data = work_salary_data;
      console.log(work_salary_data[i]);
      data.splice(i, 1);
      console.log("Sliced Data :", data);
      SetWorkSalaryData([...data]);
    }
  }

  return (
    <div>
      <div className="bg-fff pt-3 px-4 ">
        <div className="row align-items-center pb-2">
          <div className="col-md-5 col-10">
            <h6 className="mb-0 text-dark fw-bolder">USERS SALARY WORKS</h6>
          </div>
          <div className="col-md-7 col-2 justify-content-end d-flex align-items-center cursor">
            <div
              className="d-flex align-items-center text-dark pe-3 "
              onClick={() => {
                // SetIsDrawerOpen(true);
                console.log("SetopenAddModal");
                SetopenAddModal(!openAddModal);
              }}
            >
              <img
                src={require("../../../assets/icon/svg/plus1.svg")}
                className="pe-2"
              />{" "}
              Add
            </div>
          </div>
        </div>
        {/* <nav className="pt-1 sticky-tabs">
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className="nav-link active"
            id="active-salary-tab"
            data-bs-toggle="tab"
            data-bs-target="#active-salary"
            type="button"
            role="tab"
            aria-controls="active-salary"
            aria-selected="true"
          >
            Active Salary Works
          </button>
          <button
            className="nav-link"
            id="deleted-salary-tab"
            data-bs-toggle="tab"
            data-bs-target="#deleted-salary"
            type="button"
            role="tab"
            aria-controls="deleted-salary"
            aria-selected="false"
          >
            Deleted Salary Work
          </button>
        </div>
      </nav> */}
      </div>
      <div className="container tabs-after-container">
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="active-salary"
            role="tabpanel"
            aria-labelledby="active-salary-tab"
          >
            {/* <div className="card px-4 py-3 mb-5">
              <div className="row p-3">
                <div className="col-md-8 pb-2">
                  <div className="d-flex align-items-center">
                    <p className="mb-0 pe-2">Show</p>
                    <select className="form-select flex-basis-20" aria-label="Default select example">
                      <option selected value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                    <p className="mb-0 ps-2">records per page</p>
                  </div>
                </div>
                <div className="col-md-4 pb-2 text-end">
                  <input type="text" className="form-control" id="staticEmail" placeholder="Search in recors..." />
                </div>
              </div>

              <table className="table table-hover">
                <thead className="table-headers">
                  {table_header.map((head, t_index) => (
                    <div className={"custom-table-header flex-basis-" + head.width} key={t_index}>
                      <p>{head.name}</p>
                    </div>
                  ))}
                </thead>
                <tbody >
                  {work_salary_data.map((data, w_index) => (
                    <div key={w_index}>
                      <div className="d-md-block d-sm-none">
                        <div className="custom-table-row align-items-center" >
                          <div className="custom-table-cell flex-basis-10">
                            <div className="center-wrapper px-2">
                              {data.profile_picture == null ? (
                                <img src={require("../../../assets/img/profile.png")} className="w-50 h-50 img-radius" />
                              ) : (
                                <img src={data.profile_picture} className="w-50 h-50 img-radius" />
                              )}
                            </div>
                          </div>
                          <div className="custom-table-cell flex-basis-30">
                            <span className="mobile-column-name">
                              Users
                            </span>
                            <div className="center-wrapper">
                              <p className="mb-1">{data.user}</p>
                            </div>
                          </div>
                          <div className="custom-table-cell flex-basis-30">
                            <span className="mobile-column-name">
                              Amount
                            </span>
                            <div className="center-wrapper">
                              <p className="mb-1">{data.amount}</p>
                            </div>
                          </div>
                          <div className="custom-table-cell flex-basis-20 action-cell">
                            <div className="center-wrapper cursor">
                              <div className="dropdown">
                                <div id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                  <img src={require("../../../assets/icon/svg/more-horizontal.svg")} className="action_img cursor" />
                                </div>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                  <li><div className="dropdown-item">
                                    <div
                                      className="cursor"
                                      onClick={() => {
                                        SetViewModal({
                                          is_open: true,
                                          record: data,
                                          type: "view",
                                          record_index: w_index,
                                          is_read: true
                                        });
                                      }}
                                      style={{ marginRight: "5px" }}
                                    >
                                      <img src={require("../../../assets/icon/svg/eye.svg")} className="action_menu_img cursor" />

                                      &nbsp; View
                                    </div>
                                  </div>
                                  </li>
                                  <li><div className="dropdown-item">
                                    <div
                                      className="cursor"
                                      onClick={() => {
                                        delete_monthly_salary(w_index, data);
                                      }}
                                    >
                                      <img src={require("../../../assets/icon/svg/trash-2.svg")} className="action_menu_img cursor" />

                                      &nbsp; Delete
                                    </div>
                                  </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-md-none">
                        <div className="pb-1 border-bottom row"
                          onClick={(event) => {
                            // on_view_click();
                            SetSelectedData({ value: data, i: w_index });
                          }}
                        >
                          <div className="col-2">
                            {data.profile_picture == null ? (
                              <img src={require("../../../assets/img/profile.png")} className="w-100 img-radius" />
                            ) : (
                              <img src={data.profile_picture} className="w-100 img-radius" />
                            )}
                          </div>
                          <div className="col-10">
                            <h6 className="mb-1">{data.user}</h6>
                            <p className="text-gray"><i className="fas fa-rupee-sign pe-2"></i>{data.amount}</p>
                          </div>

                        </div>
                      </div>
                    </div>
                  ))}

                </tbody>
              </table>

              <div className="row align-items-center p-3">
                <div className="col-md-4">
                  <p>Showing 1 to 8 of 8 enteries </p>
                </div>
                <div className="col-md-8">
                  <nav className="Pager1" aria-label="pagination example">
                    <ul className="pagination pagination-circle justify-content-center">

                      <li className="page-item disabled"><a className="page-link">First</a></li>

                      <li className="page-item disabled">
                        <a className="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>

                      <li className="page-item active"><a className="page-link">1</a></li>
                      <li className="page-item"><a className="page-link">2</a></li>
                      <li className="page-item"><a className="page-link">3</a></li>
                      <li className="page-item"><a className="page-link">4</a></li>
                      <li className="page-item"><a className="page-link">5</a></li>

                      <li className="page-item">
                        <a className="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>

                      <li className="page-item"><a className="page-link">Last</a></li>

                    </ul>
                  </nav>
                </div>
              </div>
            </div> */}

            <div className="mt-3">
              <ReactDatatable
                className="table custom-style-table"
                tHeadClassName="custom-header-style"
                config={table_config}
                records={work_salary_data}
                columns={table_column}
                loading={is_loading}
              />
            </div>
          </div>

          <div
            className="tab-pane fade"
            id="deleted-salary"
            role="tabpanel"
            aria-labelledby="deleted-salary-tab"
          >
            <div className="card px-4 py-3 mb-5">
              <div className="row p-3">
                <div className="col-md-8 pb-2">
                  <div className="d-flex align-items-center">
                    <p className="mb-0 pe-2">Show</p>
                    <select
                      className="form-select flex-basis-20"
                      aria-label="Default select example"
                    >
                      <option selected value={10}>
                        10
                      </option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                    </select>
                    <p className="mb-0 ps-2">records per page</p>
                  </div>
                </div>
                <div className="col-md-4 pb-2 text-end">
                  <input
                    type="text"
                    className="form-control"
                    id="staticEmail"
                    placeholder="Search in recors..."
                  />
                </div>
              </div>

              <table className="table table-hover">
                <thead className="table-headers">
                  {table_header.map((head, t_index) => (
                    <div
                      className={"custom-table-header flex-basis-" + head.width}
                      key={t_index}
                    >
                      <p>{head.name}</p>
                    </div>
                  ))}
                </thead>
                <tbody>
                  {deleted_salary_data.map((data, d_index) => (
                    <div key={d_index}>
                      <div className="d-lg-block d-md-none">
                        <div className="custom-table-row align-items-center">
                          <div className="custom-table-cell flex-basis-10">
                            <div className="center-wrapper px-2">
                              {data.profile_picture == null ? (
                                <img
                                  src={require("../../../assets/img/profile.png")}
                                  className="w-50 h-50 img-radius"
                                />
                              ) : (
                                <img
                                  src={data.profile_picture}
                                  className="w-50 h-50 img-radius"
                                />
                              )}
                            </div>
                          </div>
                          <div className="custom-table-cell flex-basis-30">
                            <span className="mobile-column-name">Users</span>
                            <div className="center-wrapper">
                              <p className="mb-1">{data.user}</p>
                            </div>
                          </div>
                          <div className="custom-table-cell flex-basis-30">
                            <span className="mobile-column-name">
                              Deleted User
                            </span>
                            <div className="center-wrapper">
                              <p className="mb-1">{data.deleted_user}</p>
                            </div>
                          </div>
                          <div className="custom-table-cell flex-basis-20 action-cell">
                            <div className="center-wrapper cursor">
                              <div className="dropdown">
                                <div
                                  id="dropdownMenuButton1"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <img
                                    src={require("../../../assets/icon/svg/more-horizontal.svg")}
                                    className="action_img cursor"
                                  />
                                </div>
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton2"
                                >
                                  <li>
                                    <div className="dropdown-item">
                                      <div
                                        className="cursor"
                                        onClick={() => {
                                          // SetViewModal({
                                          //   is_open: true,
                                          //   record: data,
                                          //   type: "view",
                                          //   record_index: d_index,
                                          // });
                                        }}
                                        style={{ marginRight: "5px" }}
                                      >
                                        <img
                                          src={require("../../../assets/icon/svg/eye.svg")}
                                          className="action_menu_img cursor"
                                        />
                                        &nbsp; View
                                      </div>
                                    </div>
                                  </li>
                                  <li>
                                    <div className="dropdown-item">
                                      <div
                                        className="cursor"
                                        onClick={() => {
                                          // delete_monthly_salary(d_index, data);
                                        }}
                                      >
                                        <img
                                          src={require("../../../assets/icon/svg/trash-2.svg")}
                                          className="action_menu_img cursor"
                                        />
                                        &nbsp; Delete
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-lg-none">
                        <div
                          className="pb-1 border-bottom row"
                          onClick={(event) => {
                            SetViewModal({
                              is_open: true,
                              record: data,
                              type: "view",
                              record_index: d_index,
                              is_read: false,
                            });
                          }}
                        >
                          <div className="col-2 col-md-1">
                            {data.profile_picture == null ? (
                              <img
                                src={require("../../../assets/img/profile.png")}
                                className="w-100 img-radius"
                              />
                            ) : (
                              <img
                                src={data.profile_picture}
                                className="w-100 img-radius"
                              />
                            )}
                          </div>
                          <div className="col-10 col-md-11">
                            <h6 className="mb-1">{data.user}</h6>
                            <p className="text-gray">
                              <i className="fas fa-rupee-sign pe-2"></i>
                              {data.amount}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </tbody>
              </table>

              <div className="row align-items-center p-3">
                <div className="col-md-4">
                  <p>Showing 1 to 8 of 8 enteries </p>
                </div>
                <div className="col-md-8">
                  <nav className="Pager1" aria-label="pagination example">
                    <ul className="pagination pagination-circle justify-content-center">
                      <li className="page-item disabled">
                        <a className="page-link">First</a>
                      </li>

                      <li className="page-item disabled">
                        <a className="page-link" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                          <span className="sr-only">Previous</span>
                        </a>
                      </li>

                      <li className="page-item active">
                        <a className="page-link">1</a>
                      </li>
                      <li className="page-item">
                        <a className="page-link">2</a>
                      </li>
                      <li className="page-item">
                        <a className="page-link">3</a>
                      </li>
                      <li className="page-item">
                        <a className="page-link">4</a>
                      </li>
                      <li className="page-item">
                        <a className="page-link">5</a>
                      </li>

                      <li className="page-item">
                        <a className="page-link" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                          <span className="sr-only">Next</span>
                        </a>
                      </li>

                      <li className="page-item">
                        <a className="page-link">Last</a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            {/* <div className="mt-3">
            <ReactDatatable
              className="table custom-style-table"
              tHeadClassName="custom-header-style"
              config={table_config}
              records={deleted_salary_data}
              columns={delete_table_column}
              loading={is_loading}
            />
          </div> */}
          </div>
        </div>
      </div>

      <ModalAddSalaryWork
        open={openAddModal}
        data={user_id}
        close={(data) => {
          AddModalOnClose(data);
        }}
      />

      <ModelSalaryWorkView
        data={ViewModal}
        close={(data) => {
          ViewModalOnClose(data);
        }}
      />
    </div>
  );
}
